import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {useNavigate} from "react-router-dom";
import {CiCalendarDate, CiLocationOn} from "react-icons/ci";

const currencyFormat = Intl.NumberFormat('en-US');

function Orders() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [orders, setOrders] = React.useState([]);
    const [statuses, setStatuses] = React.useState([]);
    const [status, setStatus] = React.useState(null);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }
        const params = {
            count: 40,
            page: 1,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            status_id : status
        }

        API.getOrders(params)
            .then((response) => {
                setOrders(response.data);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        const sparams = {
            count: 40,
            page: 1,
            list: 1,
            orderBy: 'priority_id',
            orderType: 'asc',
        }

        API.getStatuses(sparams)
            .then((response) => {
                setStatuses(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)

    }, [status]);

    const onSelectStatus = (event, sid,color) => {
        if(sid > 0) {
            const el = document.getElementById('groups-container');
            // el.scrollLeft -= 100;
            el.scrollTo({top: 0, left: el.scrollLeft - 120, behavior: 'smooth'});
        }

        var items = document.getElementsByClassName('product-group-badge');

        for (var i = 0; i < items.length; i++) {
            items[i].style.backgroundColor = '#fff';
        }

        event.target.style.backgroundColor = color
        setStatus(sid)
    }


    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='تاریخچه سفارش ها' hasBack={false} />

            <section className="container-fluid  mt-3 py-5 rtl px-0   ">

                <div className="row  flex-row flex-nowrap mx-2 overflow-scroll product-group-row border-bottom pb-4"
                     id='groups-container'
                >
                    <div className="col-3 badge badge-pill mx-2 product-group-badge "
                         style={{backgroundColor: 'rgba(255, 152, 0, 0.6)'}}
                         onClick={
                             (e) => {
                                 onSelectStatus(e, null, 'rgba(255, 152, 0, 0.6)');

                             }
                         }
                    >
                        همه
                    </div>
                    {
                        isLoaded && statuses.map(status => {
                                return (
                                    <div className="col-3 badge badge-pill mx-2 product-group-badge " key={status.id}

                                         onClick={
                                             (e) => {
                                                 onSelectStatus(e, status.id, status.color);

                                             }
                                         }
                                    >
                                        {status.title}
                                    </div>
                                );
                            }
                        )
                    }
                </div>


                <div className="row mx-2 mb-3">
                    {
                        orders.map (order => {
                            return (
                                <div className="col-12 rtl mb-2 order-row pb-2 "
                                     key={order.id}
                                     onClick={() => navigate(`/orders/${order.id}`)}
                                >
                                    <div className="row py-2 ">
                                        <div className="col-2 fw-bold text-small-1 text-muted border-bottom pb-3 ">
                                            <img src={order.vendor.image} alt={order.vendor.title}
                                            />
                                        </div>
                                        <div className="col-7 fw-bold text-small-1 text-muted border-bottom pb-3">
                                            {order.vendor.title}
                                            <span className='badge badge-info badge-pill bg-primary-color text-center mx-2 '>
                                        {
                                            order.totalScore
                                        }
                                    </span>
                                            <div className='fw-normal text-small-2 mt-2'>
                                                <CiLocationOn className='ms-1' />
                                                {order.address.title}
                                                :
                                                &nbsp;
                                                {order.address.address.substring(0, 30)}
                                            </div>

                                        </div>
                                        <div className="col-3 text-start border-bottom pb-3">
                                            <div className='text-small-2 bg-success bg-opacity-10 text-center rounded '>
                                                {order.tracking_code}
                                            </div>
                                            <div className=' mt-3 text-center rounded bg-secondary text-small-3  bg-opacity-10' style={{color: order.last_status.color}}>
                                                {order.last_status.title}
                                            </div>

                                        </div>
                                        <div className="col-6">
                                            <div className='fw-normal text-small-2 mt-2 text-muted'>
                                                <CiCalendarDate className='ms-1' />
                                                {order.date}
                                            </div>
                                        </div>
                                        <div className="col-6 text-start text-secondary mt-2 text-small-1 fw-bolder">
                                            {
                                                order.cash_discount_percent > 0 ?
                                                    currencyFormat.format(order.pay_amount * ( 1 - (order.cash_discount_percent / 100)))
                                                    :
                                                    currencyFormat.format(order.pay_amount)
                                            }

                                            &nbsp;
                                            ریال
                                        </div>
                                    </div>
                                </div>
                            )} )
                    }
                </div>

            </section>
            <Navbar />
        </React.Fragment>
    );
}

export default Orders;